export const getRemoveScheduleModalMessage = (selectedLineItemsCount: number): string =>
  `Are you sure you want to remove Custom Pacing Schedules from ${selectedLineItemsCount} Line Item(s)?`;
